module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency-tree"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "placement": "bottom",
      "width": "300",
      "trigger": "click"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('AgencyTreeCore', _vm._g(_vm._b({
    ref: "treeCore",
    on: {
      "nodeClick": _vm.handleClickNode,
      "checkedChange": _vm.handleCheckedChange
    }
  }, 'AgencyTreeCore', _vm.$attrs, false), _vm.$listeners))], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请选择组织机构",
      "readonly": ""
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }, [_c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    attrs: {
      "slot": "append",
      "icon": "el-icon-arrow-down"
    },
    slot: "append"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-070d476a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/AgencyTree/AgencyTree.vue
// module id = 746
// module chunks = 8